'use client'

import { usePathname, useRouter } from '@/shared/i18n'
import { cn } from '@/shared/lib'
import { Select } from '@/shared/ui'

type Props = {
  title: string
  version: string
  options: { value: string; label: string }[]
}

export const TermsSelect = ({ title, version, options }: Props) => {
  const router = useRouter()
  const pathname = usePathname()

  const handleVersionChange = (value: string) => {
    router.push(`${pathname}?version=${value}`)
  }

  return (
    <div className={cn('my-15', 'max-md:mx-4 max-md:my-10')}>
      <h3 className="typo-headline2 mb-3 font-semibold text-black">{title}</h3>
      <Select.Root value={version} width={300} onChange={handleVersionChange}>
        <Select.Trigger>
          <Select.Value />
        </Select.Trigger>
        <Select.Content>
          {options.map(option => (
            <Select.Item key={option.value} value={option.value}>
              {option.label}
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Root>
    </div>
  )
}
